import { Box, Modal, styled } from '@mui/material';

export const ModalStyled = styled(Modal)(({ theme }) => ({
  zIndex: 0,
  overflow: 'auto',
  '& .MuiBackdrop-root': {
    backgroundColor: theme.palette.primaryLight.main,
  },
}));

export const ForgotPasswordStyled = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  '@supports (height: 100dvh)': {
    minHeight: '100dvh',
  },
  backgroundColor: theme.palette.primaryLight.main,
  // tablet & phone
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(6),
  },
  [theme.breakpoints.up('sm')]: {
    paddingTop: theme.spacing(6),
  },
  // desktop
  [theme.breakpoints.up('lg')]: {
    width: 670,
    margin: 'auto',
    paddingBottom: theme.spacing(4),
  },
}));
